import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  public fullScreenMode$ = new BehaviorSubject<boolean>(false);
  constructor() { }
}
